import { render } from "./PedidoHeaderView.vue?vue&type=template&id=58077b95&scoped=true"
import script from "./PedidoHeaderView.vue?vue&type=script&lang=js"
export * from "./PedidoHeaderView.vue?vue&type=script&lang=js"

import "./PedidoHeaderView.vue?vue&type=style&index=0&id=58077b95&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58077b95"]])

export default __exports__